import { getPublicChatIdsFromLocalDBByUserRoles } from "@/indexedDB/services/chats";
import { ChatEntity } from "@/indexedDB/types";
import { getPublicGroupUsersRequests } from "@/server/services/chatService";
import { PublicGroupUsersRequests } from "@/server/types/chat";
import { MemberRole } from "@/server/types/member";
import { useQueries, useQuery } from "@tanstack/react-query";

export const usePublicGroupUsersRequests = () => {
  const {
    data: publicChats,
    isLoading: loadingPublicChats,
    error: publicChatsError,
    refetch: refetchPublicChats,
  } = useQuery({
    queryKey: ["admin-user-public-chat"],
    queryFn: async () => {
      const response = await getPublicChatIdsFromLocalDBByUserRoles([
        MemberRole.ADMIN,
        MemberRole.OWNER,
      ]);
      return response;
    },
    placeholderData: [],
  });

  const publicGroupUsersRequests = useQueries({
    queries: (publicChats ?? []).map((chat) => {
      return {
        queryKey: ["public-group-users-requests", chat.id],
        queryFn: async () => {
          const response = await getPublicGroupUsersRequests(chat.id);
          return {
            chat,
            requests: response,
          };
        },
        enabled: !!publicChats && publicChats.length > 0 && !!chat.id,
        // placeholderData: [],
      };
    }),
  });

  return {
    publicChats,
    loadingPublicChats,
    publicChatsError,
    refetchPublicChats,
    publicGroupUsersRequests: publicGroupUsersRequests
      .map((query) => query.data)
      .filter(
        (
          data,
        ): data is { chat: ChatEntity; requests: PublicGroupUsersRequests } =>
          data !== undefined && data !== null,
      ),

    requestCount: publicGroupUsersRequests.reduce((count, query) => {
      if (query.data) {
        return count + query.data.requests.length;
      }
      return count;
    }, 0),
    isLoadingPublicGroupUsersRequests: publicGroupUsersRequests.some(
      (query) => query.isLoading,
    ),
    errorPublicGroupUsersRequests: publicGroupUsersRequests.some(
      (query) => query.error,
    ),
    isFetchingPublicGroupUsersRequests: publicGroupUsersRequests.some(
      (query) => query.isFetching,
    ),
    refetchPublicGroupUsersRequests: () =>
      publicGroupUsersRequests.forEach((query) => {
        query.refetch();
      }),
  };
};
